import { REMOVE_USERS, SET_USER_DATA, SET_FILTER_USER_DATA, SET_USER_PERCENTAGE, SET_TOTAL_FILTERED_USERS, SET_USERS_COUNT } from "../types";

const initialState = {
  users: [],
  filterUsers: [],
  userPercentage: 0,
  totalFilteredUsers: 0,
  userSelectionCount: 0,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return {
        ...state,
        users: action.payload,
      }
    case SET_USER_PERCENTAGE:
      return {
        ...state,
        userPercentage: action.payload,
      }
    case SET_FILTER_USER_DATA:
      return {
        ...state,
        filterUsers: action.payload,
      }
    case SET_TOTAL_FILTERED_USERS:
      return {
        ...state,
        totalFilteredUsers: action.payload,
      };
    case REMOVE_USERS: {
      return { users: [] }
    }
    case SET_USERS_COUNT:
      return {
        ...state,
        userSelectionCount: action.payload,
      };
    default:
      return state;
  }
}

export default userReducer;